import { Controller } from "@hotwired/stimulus"

// Reloads the enclosing Turbo Frame from `url` on an interval. The server stops polling by
// rendering the frame without this controller once the work reaches a terminal state; a
// replaced frame disconnects this instance, so each response decides whether polling continues.
// Connects to data-controller="poll"
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 5000 } }

  connect() {
    this.schedule()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  schedule() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.reload(), this.intervalValue)
  }

  reload() {
    const frame = this.element.closest("turbo-frame")
    if (frame && !document.hidden) {
      if (frame.getAttribute("src") === this.urlValue) frame.reload()
      else frame.src = this.urlValue
    }
    // Keeps polling if the request fails and the frame content is not replaced.
    this.schedule()
  }
}
